// PREMA – default to 2nd image, variant-aware + custom zoom overlay with arrows
document.addEventListener('DOMContentLoaded', function () {
  console.log('%c[gallery] custom-main-image v8 + lightbox + arrows', 'color: green; font-weight: bold;');

  const mainImg = document.getElementById('mainProductImage');
  const lightbox = document.getElementById('customLightbox');
  const lightboxImg = document.getElementById('customLightboxImage');

  if (!mainImg) {
    console.warn('[gallery] ❌ mainProductImage NOT FOUND. Make sure your Liquid has id="mainProductImage".');
    return;
  }

  // Get all current thumbs (for current variant)
  function getThumbLinks() {
    let links = Array.from(
      document.querySelectorAll(
        '.product-area__thumbs__thumb a, .theme-gallery-thumb a, .product-area__thumbs a'
      )
    );
    // de-duplicate
    links = links.filter((el, idx, arr) => arr.indexOf(el) === idx);
    return links;
  }

  let thumbLinks = [];
  let currentIndex = 0;

  // Swap main PDP image from a thumb
  function swapMainImageFromThumb(thumb, label) {
    if (!thumb) return;

    const fullSrc =
      thumb.getAttribute('data-full-src') || thumb.getAttribute('href');

    console.log(`[gallery] swapMainImageFromThumb (${label}) ->`, fullSrc);

    if (!fullSrc) {
      console.warn('[gallery] ❌ No href/data-full-src on thumb.');
      return;
    }

    mainImg.setAttribute('src', fullSrc);
    mainImg.setAttribute('srcset', fullSrc);

    mainImg.removeAttribute('data-src');
    mainImg.removeAttribute('data-srcset');
    mainImg.removeAttribute('data-sizes');
    mainImg.removeAttribute('sizes');
    mainImg.classList.remove('lazyload', 'lazyloaded');

    console.log('[gallery] ✅ main image updated to:', fullSrc);
  }

  // Show thumb by index (used by arrows, keyboard, initial)
  function showMediaAtIndex(index, reason) {
    if (!thumbLinks.length) return currentIndex;

    // wrap around
    if (index < 0) index = thumbLinks.length - 1;
    if (index >= thumbLinks.length) index = 0;

    const thumb = thumbLinks[index];
    thumbLinks.forEach(l => l.classList.remove('thumb-active'));
    thumb.classList.add('thumb-active');

    currentIndex = index;
    swapMainImageFromThumb(thumb, `index-${index}-${reason}`);

    // sync popup image if open
    if (lightbox && lightbox.classList.contains('is-active') && lightboxImg) {
      lightboxImg.src = mainImg.src;
    }

    return currentIndex;
  }

  // Lightbox helpers (with body class for header z-index)
  function openLightbox() {
    if (!lightbox || !lightboxImg || !mainImg) return;

    // sync currentIndex from active thumb if any
    const activeIdx = thumbLinks.findIndex(t => t.classList.contains('thumb-active'));
    if (activeIdx >= 0) currentIndex = activeIdx;

    lightboxImg.src = mainImg.src;
    lightbox.classList.add('is-active');
    lightbox.setAttribute('aria-hidden', 'false');

    document.body.classList.add('custom-lightbox-open');
  }

  function closeLightbox() {
    if (!lightbox) return;

    lightbox.classList.remove('is-active');
    lightbox.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('custom-lightbox-open');
  }

  // Attach click handler once per thumb
  function attachClickHandlers() {
    thumbLinks.forEach((link, index) => {
      if (link.__premaBound) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        console.log('[gallery] CLICK on thumb index', index, 'href=', this.getAttribute('href'));

        thumbLinks.forEach(l => l.classList.remove('thumb-active'));
        this.classList.add('thumb-active');

        currentIndex = index;
        swapMainImageFromThumb(this, `click index ${index}`);

        // if popup is open, sync the big image too
        if (lightbox && lightbox.classList.contains('is-active') && lightboxImg) {
          lightboxImg.src = mainImg.src;
        }
      });

      link.__premaBound = true;
    });
  }

  // Default = 2nd thumb of current variant
  function setDefaultSecondThumb(reason) {
    thumbLinks = getThumbLinks();
    console.log(`[gallery] setDefaultSecondThumb (${reason}) – count:`, thumbLinks.length);

    if (!thumbLinks.length) {
      console.warn('[gallery] ❌ No thumbs found in setDefaultSecondThumb.');
      return;
    }

    let chosenIndex = 0;
    if (thumbLinks.length > 1) {
      chosenIndex = 1; // 2nd image
      console.log('[gallery] choosing SECOND thumb (index 1)');
    } else {
      console.log('[gallery] only one thumb, using FIRST (index 0)');
    }

    currentIndex = chosenIndex;
    const chosen = thumbLinks[chosenIndex];

    thumbLinks.forEach(l => l.classList.remove('thumb-active'));
    chosen.classList.add('thumb-active');

    swapMainImageFromThumb(chosen, `default-${reason}`);
  }

  // Initial setup
  thumbLinks = getThumbLinks();
  console.log('[gallery] initial thumbs:', thumbLinks.length);
  attachClickHandlers();
  setDefaultSecondThumb('initial');

  // Variant change → refresh thumbs for that variant only
  const variantInputs = document.querySelectorAll(
    'form[action*="/cart/add"] [name="id"], .product-form__input input[type="radio"]'
  );

  variantInputs.forEach(input => {
    input.addEventListener('change', function () {
      console.log('[gallery] variant change detected, resetting to 2nd image for new variant...');
      setTimeout(function () {
        thumbLinks = getThumbLinks();
        attachClickHandlers();
        setDefaultSecondThumb('variant-change');
      }, 100);
    });
  });

  // Wire up the lightbox (open/close + arrows + keyboard)
  if (lightbox && lightboxImg) {
    // open on main image click
    mainImg.addEventListener('click', function () {
      // if you want zoom only on desktop, uncomment:
      // if (window.innerWidth < 769) return;
      openLightbox();
    });

    const closeBtn = lightbox.querySelector('.custom-lightbox__close');
    const backdrop = lightbox.querySelector('.custom-lightbox__backdrop');
    const prevBtn = lightbox.querySelector('.custom-lightbox__prev');
    const nextBtn = lightbox.querySelector('.custom-lightbox__next');

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLightbox();
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeLightbox);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        currentIndex = showMediaAtIndex(currentIndex - 1, 'prev-button');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        currentIndex = showMediaAtIndex(currentIndex + 1, 'next-button');
      });
    }

    // ESC / ← / → keys when popup is open
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-active')) return;

      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        currentIndex = showMediaAtIndex(currentIndex - 1, 'arrow-left');
      } else if (e.key === 'ArrowRight') {
        currentIndex = showMediaAtIndex(currentIndex + 1, 'arrow-right');
      }
    });
  } else {
    console.warn('[gallery] lightbox elements not found – zoom overlay disabled.');
  }

  window.__PREMA_MAIN_IMAGE_V8 = 'v8+lightbox+arrows';
});
